import type { ColorSchemeTypes, iconSizeMap } from '@wistia/ui';
import { Icon } from '@wistia/ui';
import { styled } from 'styled-components';
import type { JSX } from 'react';

type SpinnerType = 'full-container' | 'full-page' | 'inline';

const IconWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;

  &[data-type='full-page'] {
    min-height: 100vh;
  }

  &[data-type='full-container'] {
    min-height: 100%;
  }
`;

export const LoadingSpinner = ({
  type = 'full-page',
  size = 'lg',
  colorScheme = 'standard',
}: {
  type?: SpinnerType;
  size?: keyof typeof iconSizeMap;
  colorScheme?: ColorSchemeTypes;
}): JSX.Element => {
  return (
    <IconWrapper data-type={type}>
      <Icon
        size={size}
        type="spinner"
        colorScheme={colorScheme}
      />
    </IconWrapper>
  );
};
